module.exports = __webpack_public_path__ + "media/images/ico-bill-fd8e964aa9847c92b9ff259463c5b9ca.svg";